function frezny_product_main_gallry(doc){
  $('#mainCarousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite:false,
    loop:false,
    fade: false,
    asNavFor: '#thumbCarousel',
    prevArrow: '<button title="Next slide" class="slick-prev main_slick_prev_arrow" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>',
    nextArrow: '<button title="Next slide" class="slick-next main_slick_next_arrow" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>'
  });
            
  $('#thumbCarousel').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#mainCarousel',
    dots: false,
    arrows:true,
    infinite:false,
    loop:false,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    prevArrow: '<button title="Next slide" class="slick-prev thumb_slick_prev_arrow" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>',
    nextArrow: '<button title="Next slide" class="slick-next thumb_slick_next_arrow" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: false,
          prevArrow: '<button title="Next slide" class="slick-prev thumb_slick_prev_arrow_normal" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>',
          nextArrow: '<button title="Next slide" class="slick-next thumb_slick_next_arrow_normal" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>'
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          prevArrow: '<button title="Next slide" class="slick-prev thumb_slick_prev_arrow_normal" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg></button>',
          nextArrow: '<button title="Next slide" class="slick-next thumb_slick_next_arrow_normal" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg></button>'
        },
      },
    ]
  });  
}
function changeTabs(e) {
    const target = e.target;
    const parent = target.parentNode;
    const grandparent = parent.parentNode;
    // Remove all current selected tabs
    parent
      .querySelectorAll('[aria-selected="true"]')
      .forEach(t => t.setAttribute('aria-selected', false));

    // Set this tab as selected
    target.setAttribute('aria-selected', true);

    // Hide all tab panels
    grandparent
      .querySelectorAll('[role="tabpanel"]')
      .forEach(p => p.setAttribute('hidden', true));

    // Show the selected panel
    grandparent.parentNode
      .querySelector(`#${target.getAttribute('aria-controls')}`)
      .removeAttribute('hidden');
  }
function frenzy_size_click(){
    var el = document.querySelector('.show-size-pop');
    var el_close = document.querySelector('.close-size-popup');
    el.onclick = function() {
      // console.log('el-2-2', el);
      el.classList.toggle('showpop_sizeactv');
    }
    el_close.onclick = function(){
      el.classList.toggle('showpop_sizeactv');
    }
      $(".show-size-pop").click(function () {
        $(".size-chart-pop").addClass("showpop_sizeactv");
    });
    $(".close-size-popup").click(function () {
        $(".size-chart-pop").removeClass("showpop_sizeactv");
    });
    $(".cancel-qv-currency-2").click(function () {
        $(".size-chart-pop").removeClass("showpop_sizeactv");
    });
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');
    // Add a click event handler to each tab
    tabs.forEach(tab => {
      tab.addEventListener('click', changeTabs);
    });
    let tabFocus = 0;
    tabList.addEventListener('keydown', e => {
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute('tabindex', -1);
        if (e.keyCode === 39) {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }
        tabs[tabFocus].setAttribute('tabindex', 0);
        tabs[tabFocus].focus();
      }
    });
    fourSixtyView();
}
function ProductModal(){
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
}
async function frenzy_foursixty_gallery(doc){
  if(doc.querySelectorAll('.foursixty-section-div')){
    const iterations = doc.querySelectorAll('.foursixty-section-div').length; // Number of iterations
    const delay = 100;   
    doc.querySelectorAll('.foursixty-section-div').forEach(function(this_click, index){
       setTimeout(() => {
        if(this_click.querySelectorAll('script')){
          this_click.querySelectorAll('script').forEach(function(this_script){
            const src = this_script.getAttribute('src');
            const feed_id = this_script.getAttribute('data-feed-id') ? this_script.getAttribute('data-feed-id') : '';
            const loading_image = this_script.getAttribute('data-defer-image-loading') ? this_script.getAttribute('data-defer-image-loading') : '';
            const theme = this_script.getAttribute('data-theme') ? this_script.getAttribute('data-theme') : '';
            const filter = this_script.getAttribute('data-connector-filter') ? this_script.getAttribute('data-connector-filter') : '';
            const cell_size = this_script.getAttribute('data-cell-size') ? this_script.getAttribute('data-cell-size') : '';
            const posts = this_script.getAttribute('data-has-posts-selector') ? '#foursixty-section-div-'+ index +' '+ this_script.getAttribute('data-has-posts-selector') : '';
            const for_url = this_script.getAttribute('data-for-url') ? this_script.getAttribute('data-for-url') : '';
            const conversion = this_script.getAttribute('data-track-conversion') ? this_script.getAttribute('data-track-conversion') : '';
            const product_ids = this_script.getAttribute('data-product-ids') ? this_script.getAttribute('data-product-ids') : '';
            const prepend_detail = this_script.getAttribute('data-prepend-detail') ? this_script.getAttribute('data-prepend-detail') : '';

            const existingScript = this_click.querySelectorAll(`script[src="${src}"]`);
            if(existingScript){
              existingScript.forEach(function(exsScript){
                exsScript.remove();
              });
            }
            let script = document.createElement('script');
            if(conversion){script.setAttribute('data-track-conversion', conversion);}
            if(cell_size){script.setAttribute('data-cell-size', cell_size);}
            if(theme){script.setAttribute('data-theme',theme);}
            if(posts){script.setAttribute('data-has-posts-selector', posts);}
            if(product_ids){script.setAttribute('data-product-ids', product_ids);}
            if(prepend_detail){script.setAttribute('prepend_detail', prepend_detail);}
            if(src){script.src = src;}
            if(feed_id){script.setAttribute('data-feed-id', feed_id);}
            if(loading_image){script.setAttribute('data-defer-image-loading', loading_image);}
            if(filter){script.setAttribute('data-connector-filter', filter);}
            if(for_url){script.setAttribute('data-for-url', for_url);}
            script.type = "text/javascript";
            script.async = true;
            setTimeout(() => { 
              if (index === 0) {
                  document.querySelector('#foursixty-section-div-0 #foursixty-hideable-container').prepend(script);
              } else if (index === 1) {
                  document.querySelector('#foursixty-section-div-1 #foursixty-container').append(script);
              }
            }, 100);
            script.onload = function () {
              console.log("Script loaded successfully!");
            };
            script.onerror = function () {
              console.error("Failed to load the script.");
            };
          });
        }
      }, index * delay);
    });
  }
}
function shippingMessage(){
  if($('.disclosure').hasClass('curr-us')) {
      $('.message1').addClass('show');
  }else{
    $('.message2').addClass('show');
  }  
}

/* addition for custom bundle */
function productFromSubmit() {   
  document.querySelectorAll('.product-form__submit').forEach(function (button) {
    button.addEventListener('click', function (event) {
      frenzyAsyncItems();
    });
  });
   
 document.querySelectorAll('.bundle-button').forEach(function (customButton) {
    customButton.addEventListener('click', function (event) {
      const button = event.currentTarget;
      const form = button.closest('.product__info-wrapper').querySelector('.product-form form');
      const originalButton = button.closest('.product__info-wrapper').querySelector('.product-form [type="submit"]');       
      const input = document.createElement('input');
      input.value = 3;
      input.name = 'quantity';
      input.type = 'hidden';
      form.appendChild(input);
      originalButton.click();
       
      setTimeout(() => {
        input.remove();
      }, 200);
      
      frenzyAsyncItems();
    });
  });
}
 
document.addEventListener('DOMContentLoaded', productFromSubmit);
/* addition for custom bundle end */

function frenzyProductHtmlUpdate(dataHtml,productJson) {
  const frenzySelectors = [
      { selector: 'media-gallery' },                                                                                                                                              
      { selector: '.product__info-wrapper .title-info' },
      { selector: '.price_holder-customs' },
      { selector: 'variant-radios .size' },
      { selector: 'variant-radios .fabric' },
      { selector: 'variant-radios .color .color-namen.current_namen', updateContent: () => 'Color: ' + productJson?.getColoName },
      { selector: 'variant-radios script#frenzy-variant_script'},
      { selector: '.product_buttons-wrapper' },
      { selector: '.info-picture-wrapper.info-picture-wrapper-custom' },
      { selector: '.frenzy_bundle_id' },
      { selector: '#foursixty-section-div-0' },
      { selector: '#foursixty-section-div-1' },
      { selector: '#__st' },
      { selector: '#viewed_product'},
      { selector: '.analytics'},
      { selector: '#frenzy_variantRadios'},
      { selector: '#web-pixels-manager-setup'},
      { selector: '#product-form__noscript-wrapper'},
      { selector: '#BISModal'},
      { selector: '.frenzy_recommendation_section' },
      { selector: '.frenzy_cross_sell_carousel_section' }
      // { selector: 'variant-radios [type="application/json"]' }
    ];
    frenzySelectors.forEach(({ selector, updateContent }) => {
      const frenzyElement = document.querySelector(selector);
      if (frenzyElement) {
        frenzyElement.innerHTML = updateContent ? updateContent() : dataHtml.querySelector(selector).innerHTML;
      }
    });

    if(document.querySelector('variant-radios .color .opt-Color legend .color-val-text')){
      document.querySelector('variant-radios .color .opt-Color legend .color-val-text').innerHTML = productJson.getColoName;
    }
    if(document.querySelector('variant-radios .color .opt-Color .fix_for_colors_sp input')){
      document.querySelector('variant-radios .color .opt-Color .fix_for_colors_sp input').value = productJson.getColoName;
    }
    const frenzy_acc = document.querySelectorAll('.frenzy-accordion');
    frenzy_acc.forEach((acc_item) => {
      const dataIndex = acc_item.getAttribute('data-index');
      acc_item.innerHTML = dataHtml.querySelector('.frenzy-accordion[data-index="'+dataIndex+'"]').innerHTML;
    });
    
    const frenzy_appSection = document.querySelectorAll('.product-app-block.desktops');
    frenzy_appSection.forEach((app_item) => {
      const appdataIndex = app_item.getAttribute('data-appIndex');
      app_item.innerHTML = dataHtml.querySelector('.product-app-block.desktops[data-appIndex="'+appdataIndex+'"]').innerHTML;
    });
    
    if(document.querySelector('#stamped-main-widget')){
      document.querySelector('#stamped-main-widget').closest('.shopify-app-block').innerHTML = dataHtml.querySelector('#stamped-main-widget').outerHTML;
    }
    const frenzyVariants = document.querySelector('variant-radios').setAttribute('data-url','/products/'+productJson.prodHandle);
    let currentUrl = window.location.href;
    let updatedUrl = currentUrl.replace(/(products\/)[^/]+/, `$1${productJson.prodHandle}`);
    window.history.replaceState(null, "", updatedUrl);
    document.getElementById('breadcrumb').querySelector('.page-title1').innerHTML = productJson.prodTitle;
    document.body.classList.add('template--product');
    if(__st && __st.pageurl){
      __st.pageurl = updatedUrl;
      __st.rid = productJson.prodID;
    }
    
    productFromSubmit();
    frenzy_size_click();
    frezny_product_main_gallry(document.querySelector('main'));
    frenzy_foursixty_gallery(document.querySelector('main'));
    product_id_Frenzy = productJson.prodID;
    variant_id_Frenzy = productJson.prodVarID;

    setTimeout(() => {
      frenzyScriptReload();
      $frenzy_bundle_event();
      StampedFn.reloadUGC();
      shippingMessage();
    }, 1000)
    setTimeout(function(){
      frenzy_set_height_gallry_section(1);
    },100);
    // document.dispatchEvent(new CustomEvent('swym:product-changed', {detail: {data: productJson}}));
}
async function updateMainContent(productJson){
  try {
    const response = await fetch(productJson.updateURL);
    const data = await response.text();
    const new_HTML = new DOMParser().parseFromString(data, "text/html");
    frenzyProductHtmlUpdate(new_HTML,productJson);
  } catch (error) {
    console.log('Section id not found...', error);
  }
}

// Color click update start
function frenzy_main_product_call__() {
  const colorItems = document.querySelectorAll('.color-groups-color-swatches .cross_linked_products');
  const colorContainer = document.querySelector('.color-groups-color-swatches');
  if (!colorItems.length || !colorContainer) return;
  colorContainer.addEventListener('click', function (e) {
    const target = e.target.closest('.cross_linked_products');
    if (!target || !colorContainer.contains(target)) return;
    e.preventDefault();
    e.stopPropagation();
    if (target.classList.contains('processing')) return;
    colorItems.forEach(item => item.classList.add('loading'));
    target.classList.add('processing');
    const sectionID = '{{ section.id }}';
    const getColoName = (target.dataset.color || '').trim();
    const prodHandle = target.dataset.handle;
    const prodID = target.dataset.prodid;
    const prodVarID = target.dataset.varid;
    const prodTitle = target.dataset.title;
    if (!prodHandle) {
      console.error('Missing product handle');
      colorItems.forEach(item => item.classList.remove('loading', 'processing'));
      return;
    }
    const newHandle = prodHandle.replace(/-/g, '_');
    const checkPData = typeof frenzyProductDATAHtml !== 'undefined' ? frenzyProductDATAHtml[newHandle] : null;
    colorItems.forEach(item => item.classList.remove('current_product'));
    target.classList.add('current_product');

    document.querySelectorAll('.color-names span').forEach(span => {
      span.classList.remove('current_namen');
      if (span.dataset.color === getColoName) {
        span.classList.add('current_namen');
      }
    });
    const updateURL = `${window.location.origin}/products/${prodHandle}`;
    const productJson = {
      sectionID,
      getColoName,
      prodHandle,
      prodID,
      prodVarID,
      prodTitle,
      updateURL
    };
    try {
      if (checkPData) {
        frenzyProductHtmlUpdate(checkPData, productJson);
      } else {
        updateMainContent(productJson);
      }
    } catch (error) {
      console.error('Error updating product:', error);
    }
    setTimeout(() => {
      colorItems.forEach(item => item.classList.remove('loading', 'processing'));
    }, 2000);
  });
  colorItems.forEach(item => {
    item.addEventListener('click', function () {
      setTimeout(() => {
        if (!item.classList.contains('processing') && !item.classList.contains('loading')) {
          item.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }
      }, 10);
    });
  });
}
window.addEventListener('load', () => {
  setTimeout(() => {
    frenzy_main_product_call__();
  }, 500);
});
document.addEventListener('DOMContentLoaded', () => {
  const colorContainer = document.querySelector('.color-groups-color-swatches');
  if (!colorContainer) return;

  colorContainer.addEventListener('touchstart', (e) => {
    const target = e.target.closest('.cross_linked_products');
    if (target) target.classList.add('touched');
  });
  colorContainer.addEventListener('touchend', (e) => {
    const target = e.target.closest('.cross_linked_products');
    if (target && target.classList.contains('touched')) {
      target.classList.remove('touched');
      setTimeout(() => {
        target.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }, 50);
    }
  });
});
// Color click update end

function frenzy_set_height_gallry_section(status){
  const mainCarousel_height = document.querySelector('.height-mainCarousel').clientHeight;
  const thumbCarousel_height = document.querySelector('.height-thumbCarousel').clientHeight;
  const review_badge_height = document.querySelector('.stamped-product-reviews-badge').clientHeight;
  let custom_styles = '.height-mainCarousel{min-height:'+mainCarousel_height+'px;}.height-thumbCarousel{min-height:'+thumbCarousel_height+'px;}.stamped-product-reviews-badge{min-height:'+review_badge_height+'px;}';
  const update_style = '<style id="gallery_style">'+custom_styles+'</style>';
  if(status == 1){
    const gallery_style = document.querySelector('#gallery_style');
    if(gallery_style){
      gallery_style.innerHTML = custom_styles;
    }
  }else{
    const main_content = document.querySelector('#MainContent');
    if(main_content){
      main_content.insertAdjacentHTML("beforebegin", update_style);  
    } 
  }
}
let frenzyProductDATAHtml = {};

async function getAllProdDataNew(fetchUrl, prodHandle) {
  try {
    const response = await fetch(fetchUrl);
    const data = await response.text();
    const fetch_HTML = new DOMParser().parseFromString(data, "text/html");
    frenzyProductDATAHtml[prodHandle] = fetch_HTML;
  } catch (error) {
    console.error(error);
  }
}
document.addEventListener('DOMContentLoaded', async function() {
  setTimeout(function() {
    if (__st && __st.p == 'product') {
      frenzy_set_height_gallry_section(0);
    }
  }, 100);
  const getAllColorsItem = document.querySelectorAll('.color-groups-color-swatches .cross_linked_products');
  if(getAllColorsItem){
    await Promise.all(Array.from(getAllColorsItem).map(async function(this_click) {
      const prodHandle = this_click.getAttribute('data-handle');
      const fetchUrl = window.location.origin + '/products/' + prodHandle;
      if(prodHandle){
        await getAllProdDataNew(fetchUrl, prodHandle.replaceAll('-', '_'));
      }
    }));
  }
  frenzy_main_product_call__();
});
